import { location as routerLocation, LocationActions } from "@hyperapp/router";

// common/categories
export { fetchCategories } from "./common/categories/actions/fetch-categories";
export { setCategories } from "./common/categories/actions/set-categories";
export { setCategory } from "./common/categories/actions/set-category";

// common/portifolios
export {
  fetchPortifolios,
} from "./common/portifolios/actions/fetch-portifolios";
export { setPortifolios } from "./common/portifolios/actions/set-portifolios";
export { setPortifolio } from "./common/portifolios/actions/set-portifolio";

// column-selector
export { loadColumns } from "./common/column-selector/actions/load-columns";
export { saveColumns } from "./common/column-selector/actions/save-columns";
export { setColumns } from "./common/column-selector/actions/set-columns";
export {
  toggleColumnState,
} from "./common/column-selector/actions/toggle-column-state";

// common/list-item-selector
export {
  setAllSelected,
} from "./common/list-item-selector/actions/set-all-selected";
export { setSelected } from "./common/list-item-selector/actions/set-selected";

// common/pagination
export { setPagination } from "./common/pagination/actions/set-pagination";

// common/sidebar
export {
  autocloseSidebar,
} from "./common/navsidebar/actions/autoclose-sidebar";
export {
  keepSidebarHandlerInPosition,
} from "./common/navsidebar/actions/keep-sidebar-handler-in-position";
export {
  toggleSidebarState,
} from "./common/navsidebar/actions/toggle-sidebar-state";

// common/users
export { fetchUsers } from "./common/users/actions/fetch-users";
export { setUser } from "./common/users/actions/set-user";
export { setUsers } from "./common/users/actions/set-users";

// sections/places
export { fetchPlaces } from "./sections/places/actions/fetch-places";
export { fetchPlacesCount } from "./sections/places/actions/fetch-places-count";
export { setPlaces } from "./sections/places/actions/set-places";
export { setPlaceCount } from "./sections/places/actions/set-places-count";
export { setPlacesFailed } from "./sections/places/actions/set-places-failed";

// sections/scheduling
export {
  resetScheduling,
} from "./sections/scheduling/actions/reset-scheduling";
export { sendProtoTasks } from "./sections/scheduling/actions/send-proto-tasks";
export {
  setSchedulingQueryStringData,
} from "./sections/scheduling/actions/set-scheduling-query-string-data";
export {
  setProtoTasksDate,
} from "./sections/scheduling/actions/set-proto-tasks-date";
export {
  setSendingProtoTasksFailed,
} from "./sections/scheduling/actions/set-sending-proto-tasks-failed";
export {
  setSendingProtoTasksSucceded,
} from "./sections/scheduling/actions/set-sending-proto-tasks-succeded";

// sections/unvisited-places
export {
  fetchUnvisitedPlaces,
} from "./sections/unvisited-places/actions/fetch-unvisited-places";
export {
  fetchUnvisitedPlacesCount,
} from "./sections/unvisited-places/actions/fetch-unvisited-places-count";
export { setSince } from "./sections/unvisited-places/actions/set-since";
export { setUntil } from "./sections/unvisited-places/actions/set-until";

export {
  setUnvisitedPlaces,
} from "./sections/unvisited-places/actions/set-unvisited-places";
export {
  setHasSelectedPlace,
} from "./sections/unvisited-places/actions/set-has-selected-place";

export {
  setSelectedPlace,
} from "./sections/unvisited-places/actions/set-selected-place";
export {
  setUnvisitedPlacesCount,
} from "./sections/unvisited-places/actions/set-unvisited-places-count";
export {
  setUnvisitedPlacesFailed,
} from "./sections/unvisited-places/actions/set-unvisited-places-failed";
export {
  setUnvisitedPlacesKeyword,
} from "./sections/unvisited-places/actions/set-unvisited-places-keyword";

// sections/unvisited-places-nearby
export {
  fetchUnvisitedPlacesNearby,
} from "./sections/unvisited-places-nearby/actions/fetch-unvisited-places-nearby";
export {
  fetchUnvisitedPlacesNearbyCount,
} from "./sections/unvisited-places-nearby/actions/fetch-unvisited-places-nearby-count";
export {
  setRadius,
} from "./sections/unvisited-places-nearby/actions/set-radius";
export {
  setUnvisitedPlacesNearby,
} from "./sections/unvisited-places-nearby/actions/set-unvisited-places-nearby";
export {
  setUnvisitedPlacesNearbyCount,
} from "./sections/unvisited-places-nearby/actions/set-unvisited-places-nearby-count";
export {
  setUnvisitedPlacesNearbyFailed,
} from "./sections/unvisited-places-nearby/actions/set-unvisited-places-nearby-failed";
export {
  setUnvisitedPlacesNearbybyQueryStringData,
} from "./sections/unvisited-places-nearby/actions/set-unvisited-places-nearby-query-string-data";
export {
  setUnvisitedPlacesNearbyKeyword,
} from "./sections/unvisited-places-nearby/actions/set-unvisited-places-nearby-keyword";

export const getState = () => state => state;
export const location: LocationActions = routerLocation.actions;
export const setState = state => () => state;
